import {TimeIntervalBO} from "./models/time-interval-bo";

export class TimeIntervalHelper {

  /**
   * (Floor) Rounds time to the nearest 15 minutes. (Use for start time)
   * @param time time in milliseconds
   * @param intervalDuration time in milliseconds (e.g. 15 minutes = 15 * 60 * 1000)
   */
  static floorTimeToQuarter(time: Date, intervalDuration: number): Date {
    return new Date(Math.floor(+time / (intervalDuration)) * (intervalDuration));
  }

  /**
   * (Ceil) Rounds time to the nearest 15 minutes. (Use for end time)
   * @param time time in milliseconds
   * @param intervalDuration time in milliseconds (e.g. 15 minutes = 15 * 60 * 1000)
   */
  static ceilTimeToQuarter(time: Date, intervalDuration: number): Date {
    return new Date(Math.ceil(+ time / (intervalDuration)) * (intervalDuration));
  }




  /**
   * Converts a full datestring to millisecond timestamp
   * e.g. "Sat Jun 03 2023 20:00:00 GMT+0200 (Mitteleuropäische Sommerzeit)" -> 1685815200000
   * @param time time in milliseconds
   * @return time in timestamp (milliseconds) format
   */
  static datestringToTimestamp(time: string): number {
    let dateObj = new Date(time);
    return dateObj.getTime();
  }

  static dateToIntervalIndexTIBO(time: Date, timeIntervalBO: TimeIntervalBO): number {
    return TimeIntervalHelper.dateToIntervalIndex(time, timeIntervalBO.roundedStartTime, timeIntervalBO.intervalDuration);
  }

  /**
   * Converts a timestamp to its interval Index
   * @param timeOffset time offset in milliseconds
   * @param time time to convert to interval index (time must be absolute)
   * @param intervalDuration base interval duration. Time in milliseconds (15 minutes = 15 * 60 * 1000)
   */
  static dateToIntervalIndex(time: Date, timeOffset: Date, intervalDuration: number): number {
    return Math.floor((+time - +timeOffset ) / intervalDuration);
  }

  /**
   * Returns the number of intervals between the start and end time. Always rounds up.
   * @param startTime start time in milliseconds
   * @param endTime end time in milliseconds
   * @param intervalDuration time in milliseconds (15 minutes = 15 * 60 * 1000)
   */
  static calculateIntervalCount(startTime: Date, endTime: Date, intervalDuration: number): number {
    // The plus converts the date to a number
    return Math.ceil(((+endTime) - (+startTime)) / (intervalDuration));
  }

  /**
   *
   * @param startTime
   * @param endTime
   */
  static timespanToLabel(startTime: number, endTime: number): string {
    let startTimeDate = new Date(startTime);
    let endTimeDate = new Date(endTime);


    // Todo map to locale Time instead of UTC
    return TimeIntervalHelper.removeDayFromDatetimeString(startTimeDate.toLocaleString()) + " - " + TimeIntervalHelper.removeDayFromDatetimeString(endTimeDate.toLocaleString());
  }

  /**
   * Beautifies the date string by returning only the time
   * @param str
   */
  static removeDayFromDatetimeString(str: string) {
    let substr = str.substring(str.indexOf(",") + 2, str.length);
    return substr.substring(0, substr.length - 3)
  }

  // static intervalIndexToIntervalMultipleIndex()

}

/**
 * (Ceil) Rounds time to the nearest 15 minutes. (Use for end time)
 * @param time time in milliseconds
 * @param intervalDuration time in milliseconds (15 minutes = 15 * 60 * 1000)
 */
/*static ceilTimeToQuarter(time: number, intervalDuration: number): number {
  return Math.ceil(time / (intervalDuration)) * (intervalDuration)
}*/

/**
 * (Floor) Rounds time to the nearest 15 minutes. (Use for start time)
 * @param time time in milliseconds
 * @param intervalDuration time in milliseconds (15 minutes = 15 * 60 * 1000)
 */
/*
static floorTimeToQuarter(time: number, intervalDuration: number): number {
  return Math.floor(time / (intervalDuration)) * (intervalDuration)
}*/
